import React from "react";
import offerImage from "assets/images/offer.png";
import { Link } from "react-router-dom/cjs/react-router-dom";
const Offers = () => {
	// const navigate = useNavigate()
	return (
		<div className="container-fluid px-md-5 py-md-5">
			<div className="row">
				<div className="col-md-6">
					<Link to="/resales">
						<div className="explore">
							<h2 className="explore-title">
								<span className="gotham-font fw-bold">explore</span>
								<span className="bask-font mx-2">Resale Properties</span>
							</h2>
							<p className="textSub">Choose Your Unit Now</p>
						</div>
					</Link>
				</div>
				<div className="col-md-6">
					<Link to="/special-offers">
						<div className="special">
							<h2 className="explore-title">
								<span className="bask-font">special deals</span>
							</h2>
							<p className="textSub mx-5">for a limited time</p>
							<p className="textSub">Choose Your Unit Now</p>
						</div>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Offers;
